import React from "react";
import Navb from "../../../../components/navbar/Navb";
import Footer from "../../../../components/footer/Footer";
import RecipiePage from "../../../../components/recipiePage/RecipiePage";
import Recpiesimg1 from "./recpiesimg1.png";
import Recpiesimg2 from "./recpiesimg2.png";
import Recpiesimg3 from "../../img14.png";
import Recpiesimg4 from "../../img2.png";
import Recpiesimg5 from "../../img3.png";
import Img1 from "./img1.png";
import Timer from "../timer.png";
import "../recipe.css";
const Besankadhirice = () => {
  return (
    <>
    <RecipiePage
        Recpiesimg1={Recpiesimg1}
        Recpiesimg2={Recpiesimg2}
        Recpiesimg3={Recpiesimg3}
        Recpiesimg4={Recpiesimg4}
        Recpiesimg5={Recpiesimg5}
        Img1={Img1}
        Name="Besan Kadhi & Rice"
        Ul1={
          <ul>
            <li>
            <span className="Bold">Nandi besan (chickpea flour)</span>
            </li>
            <li>yogurt</li>
            <li>Water</li>
            <li>ginger, grated </li>
            <li>green chili, finely chopped</li>
            <li>turmeric powder</li>
          </ul>
        }
        Ul2={
          <ul className="noDecoration">
            <li>1 cups</li>
            <li>2 cups</li>
            <li>4 tablespoons </li>
            <li>1 tablespoons</li>
            <li>1 piece</li>
            <li>1/2 teaspoon</li>
          </ul>
        }
        Ul3={
          <ul>
            <li>ghee</li>
            <li>mustard seeds</li>
            <li> cumin seeds</li>
            <li>fenugreek seeds</li>
            <li>red chilies</li>
            <li>asafoetida (hing)</li>
          </ul>
        }
        Ul4={
          <ul className="noDecoration">
            <li>2 tablespoons</li>
            <li>1 teaspoon</li>
            <li>1 teaspoon</li>
            <li>1/2 teaspoon</li>
            <li>2-3 dried</li>
            <li>A pinch</li>
          </ul>
        }
        Ol1={
          <ol>
            <li>
              In a bowl, whisk besan, yogurt, water, grated ginger, green chili,
              turmeric powder, and salt until smooth.
            </li>
            <li>
              Heat the mixture in a pan, stirring continuously to avoid lumps.
              Bring it to a boil and then simmer until the kadhi thickens.
            </li>
            <li>
              In a separate pan, heat ghee for tempering. Add mustard seeds,
              cumin seeds, fenugreek seeds, dried red chilies, asafoetida, and
              curry leaves. Let the spices splutter.
            </li>
            <li>Pour the tempering over the kadhi and mix well.</li>
            <li>Serve Besan Kadhi hot with steamed rice or chapati.</li>
          </ol>
        }
        Item1="Atta Momos"
        Item2="Mix Veg Paratha"
        Item3="Biscuit"
        Link1="wholeattavegmomos"
        Link2="mixvegparatha"
        Link3="wholeattacookies"
      />
      {/* <Navb />
      <div className="singleRecipeTop">Besan Kadhi & Rice</div>
      <img className="singleRecipeTopimg" src={Recpiesimg1} alt="Recpiesimg1" />
      <div className="singleRecipeBot">
        <div className="singleRecipeBotLeftItems">
          <div className="singleRecipeBotLeftItemTitle">INGREDIENTS</div>
          <hr />
          <div className="singleRecipeBotLeftItem">
            <div className="singleRecipeBotLeftItemTop">For Kadhi:</div>
            <ol>
              <li>
                1 cup{" "}
                <span className="Bold">Nandi besan (chickpea flour)</span>{" "}
              </li>
              <li>2 cups yogurt</li>
              <li>4 cups water</li>
              <li>1 teaspoon ginger, grated</li>
              <li>1 green chili, finely chopped</li>
              <li>1/2 teaspoon turmeric powder</li>
              <li>Salt to taste</li>
            </ol>
          </div>
          <div className="singleRecipeBotLeftItem">
            <div className="singleRecipeBotLeftItemTop">For Tempering:</div>
            <ol>
              <li>2 tablespoons ghee</li>
              <li>1 teaspoon mustard seeds</li>
              <li>1 teaspoon cumin seeds</li>
              <li>1/2 teaspoon fenugreek seeds</li>
              <li>2-3 dried red chilies</li>
              <li>A pinch of asafoetida (hing)</li>
              <li>Curry leaves</li>
            </ol>
          </div>
          <hr />
          <div className="flexitemrecipe">
            <img src={Recpiesimg2} alt="Recpiesimg2" />
            Nandi Besan
          </div>
        </div>
        <div className="singleRecipeBotRight">
          <div className="singleRecipeBotRightTop">Instructions</div>
          <ol>
            <li>
              In a bowl, whisk besan, yogurt, water, grated ginger, green chili,
              turmeric powder, and salt until smooth.
            </li>
            <li>
              Heat the mixture in a pan, stirring continuously to avoid lumps.
              Bring it to a boil and then simmer until the kadhi thickens.
            </li>
            <li>
              In a separate pan, heat ghee for tempering. Add mustard seeds,
              cumin seeds, fenugreek seeds, dried red chilies, asafoetida, and
              curry leaves. Let the spices splutter.
            </li>
            <li>Pour the tempering over the kadhi and mix well.</li>
            <li>Serve Besan Kadhi hot with steamed rice or chapati.</li>
          </ol>
        </div>
      </div>
      <div className="singleRecipeEnd">
        <div className="singleRecipeEndTitle">You Might Also Like</div>
        <div className="singleRecipeEndItems">
          <div className="singleRecipeEndItem">
            <div className="singleRecipeEndItemTop">
              <a href="/recipes/maidavegpizzacones">
                <img src={Recpiesimg3} alt="Recpiesimg3" />
                <div className="singleRecipeEndItemTitle">Maida Pizza Cone</div>
              </a>
            </div>
            <div>
              <img src={Timer} alt="Timer" />
              <span>Ready in 40 mins</span>
            </div>
          </div>
          <div className="singleRecipeEndItem">
            <div className="singleRecipeEndItemTop">
              <a href="/recipes/wholeattavegmomos">
                <img src={Recpiesimg4} alt="Recpiesimg4" />
                <div className="singleRecipeEndItemTitle">
                  Whole Atta Veg Momos
                </div>
              </a>
            </div>
            <div>
              <img src={Timer} alt="Timer" />
              <span>Ready in 40 mins</span>
            </div>
          </div>
          <div className="singleRecipeEndItem">
            <div className="singleRecipeEndItemTop">
              <a href="/recipes/soojidhokla">
                <img src={Recpiesimg5} alt="Recpiesimg5" />
                <div className="singleRecipeEndItemTitle">Sooji Dhokla</div>
              </a>
            </div>
            <div>
              <img src={Timer} alt="Timer" />
              <span>Ready in 30 mins</span>
            </div>
          </div>
        </div>
      </div>
      <Footer /> */}
    </>
  );
};

export default Besankadhirice;
